import { render, staticRenderFns } from "./UserClassHour.vue?vue&type=template&id=4c12c3f0&scoped=true"
import script from "./UserClassHour.vue?vue&type=script&lang=js"
export * from "./UserClassHour.vue?vue&type=script&lang=js"
import style0 from "./UserClassHour.vue?vue&type=style&index=0&id=4c12c3f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12c3f0",
  null
  
)

export default component.exports